const SvgIconDarkmode = (props) => (
  <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18c-2.5 0-4.625-.875-6.375-2.625S0 11.5 0 9s.875-4.625 2.625-6.375S6.5 0 9 0c.133 0 .275.004.425.013.15.008.342.02.575.037a5.461 5.461 0 0 0-1.4 1.975A6.256 6.256 0 0 0 8.1 4.5c0 1.5.525 2.775 1.575 3.825C10.725 9.375 12 9.9 13.5 9.9c.867 0 1.692-.154 2.475-.463.783-.308 1.442-.737 1.975-1.287.017.2.03.362.038.487S18 8.883 18 9c0 2.5-.875 4.625-2.625 6.375S11.5 18 9 18Z" />
  </svg>
);

export default SvgIconDarkmode;
